import pathnameWithoutLocale from '@/core/utils/pathname-without-locale';

/**
 * Fetches the path for the target locale from Uniform (localized routes).
 * Returns the current path without locale if the API does not return a path (non-Uniform route or error).
 */
export default async function getLocalizedPathFromApi(
  pathname: string,
  currentLocale: string,
  targetLocale: string,
): Promise<string> {
  try {
    const params = new URLSearchParams({
      pathname,
      currentLocale,
      targetLocale,
    });
    const res = await fetch(`/api/localized-path?${params.toString()}`);
    if (!res.ok) return pathnameWithoutLocale(pathname);
    const data = (await res.json()) as { path?: string | null };
    if (typeof data.path === 'string' && data.path) return data.path;
  } catch {
    // ignore
  }
  return pathnameWithoutLocale(pathname);
}
